module.exports = __webpack_public_path__ + "img/oficina-pinas.26dce0fd.jpg";